import { SelectionModel } from "@angular/cdk/collections";
import { Component, ViewChild, Inject } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatStepper, MatStepperModule } from "@angular/material/stepper";
import { MatTableDataSource } from "@angular/material/table";
import { PaginationInstance } from "ngx-pagination";
import { AssignCourseComponent } from "src/app/pages/courses/assign-course/assign-course.component";
import { AppService } from "src/app/services/app/app.service";
import { CommonService } from "src/app/services/common/common.service";
import { GlobalService } from "src/app/services/global/global.service";
import { RulesService } from "src/app/services/rules/rules.service";
//yes:1,no:2
//hmd :- 1 = hour, 2 = minute, 3 = day
//af_bf:- 0 = after , 1 = before
interface OvertimeWeekDays {
  daily_overtime: string[];
  partial_day_overtime: string[];
  premium_time:[];
  night_premium: [];
  consecutive_days_overtime: string[];
}
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent {
  public selectedSetting: any;
  public settingsArr: any[] = [
    { name: "General", icon: "fa-cog", id: 0, u_typ: ['company', 'recruiter'] },
    { name: "Payroll", icon: "fa-cog", id: 1, u_typ: ['recruiter'] },
    { name: "Overtime", icon: "fa-cog", id: 2, u_typ: ['company', 'recruiter'] },
    { name: "Breaks", icon: "fa-cog", id: 3, u_typ: ['company', 'recruiter'] },
    { name: "Shift attachments", icon: "fa-cog", id: 4, u_typ: ['company', 'recruiter'] },
    { name: "Geolocation", icon: "fa-cog", id: 5, u_typ: ['company', 'recruiter'] },
    { name: "Reminders", icon: "fa-cog", id: 6, u_typ: ['company', 'recruiter'] },
    { name: "Notification", icon: "fa-cog", id: 7, u_typ: ['company', 'recruiter'] },
    { name: "Limitation", icon: "fa-cog", id: 8, u_typ: ['company', 'recruiter'] },
  ]
  selectedOption: string = '';  // Track the selected option
  requiresAdminApproval = true;
  timeOffLimitations = false;
  timeOffLimitDays = 7;
  timeOffUnit = "days";
  displayedColumns: string[] = ["select", "demo-name", "demo-groups"];
  public workdays = [
    { label: "S", value: "sun", selected: false, hours: "8" },
    { label: "M", value: "mon", selected: false, hours: "8" },
    { label: "T", value: "tues", selected: false, hours: "8" },
    { label: "W", value: "wed", selected: false, hours: "8" },
    { label: "T", value: "thur", selected: false, hours: "8" },
    { label: "F", value: "fri", selected: false, hours: "8" },
    { label: "S", value: "sat", selected: false, hours: "8" },
  ];
  public remDays = [
    { label: "S", value: "sun", selected: false, },
    { label: "M", value: "mon", selected: false, },
    { label: "T", value: "tues", selected: false, },
    { label: "W", value: "wed", selected: false, },
    { label: "T", value: "thur", selected: false, },
    { label: "F", value: "fri", selected: false, },
    { label: "S", value: "sat", selected: false, },
  ];
  public hoursArr: any[] = [
    { key: "2 hours", val: 2 },
    { key: "2:30 hours", val: 2.5 },
    { key: "3 hours", val: 3 },
    { key: "3:30 hours", val: 3.5 },
    { key: "4 hours", val: 4 },
    { key: "4:30 hours", val: 4.5 },
    { key: "5 hours", val: 5 },
    { key: "5:30 hours", val: 5.5 },
    { key: "6 hours", val: 6 },
    { key: "6:30 hours", val: 6.5 },
    { key: "7 hours", val: 7 },
    { key: "7:30 hours", val: 7.5 },
    { key: "8 hours", val: 8 },
    { key: "8:30 hours", val: 8.5 },
    { key: "9 hours", val: 9 },
    { key: "9:30 hours", val: 9.5 },
    { key: "10 hours", val: 10 },
    { key: "10:30 hours", val: 10.5 },
    { key: "11 hours", val: 11 },
    { key: "11:30 hours", val: 11.5 },
    { key: "12 hours", val: 12 },
    { key: "12:30 hours", val: 12.5 },
    { key: "13 hours", val: 13 },
    { key: "13:30 hours", val: 13.5 },
    { key: "14 hours", val: 14 },
    { key: "14:30 hours", val: 14.5 },
    { key: "15 hours", val: 15 },
    { key: "15:30 hours", val: 15.5 },
    { key: "16 hours", val: 16 },
    { key: "16:30 hours", val: 16.5 },
    { key: "17 hours", val: 17 },
    { key: "17:30 hours", val: 17.5 },
    { key: "18 hours", val: 18 },
    { key: "18:30 hours", val: 18.5 },
    { key: "19 hours", val: 19 },
    { key: "19:30 hours", val: 19.5 },
    { key: "20 hours", val: 20 },
    { key: "20:30 hours", val: 20.5 },
    { key: "21 hours", val: 21 },
    { key: "21:30 hours", val: 21.5 },
    { key: "22 hours", val: 22 },
    { key: "22:30 hours", val: 22.5 },
    { key: "23 hours", val: 23 },
    { key: "23:30 hours", val: 23.5 }
  ];
  public weekDaysArr: any[] = [
    { key: "Sunday", val: 'sun' },
    { key: "Monday", val: 'tues' },
    { key: "Tuesday", val: 'tues' },
    { key: "Wednesday", val: 'wed' },
    { key: "Thursday", val: 'thur' },
    { key: "Friday", val: 'fri' },
    { key: "Saturday", val: 'sat' },
  ]
  public roundingVal: any[] = [
    { key: "5 minutes", val: 5 },
    { key: "10 minutes", val: 10 },
    { key: "15 minutes", val: 15 },
    { key: "20 minutes", val: 20 },
    { key: "25 minutes", val: 25 },
    { key: "30 minutes", val: 30 }
  ]
  public payrollCycleArr: any[] = [
    { key: "7 days", val: 7 },
    { key: "15 days", val: 15 },
    { key: "30 days", val: 30 },
  ]
  public durationArr: any[] = [
    { key: "Days", val: 3 },
    { key: "Hours", val: 1 }
  ]
  public timePeriodArr: any[] = [
    { key: "After", val: 0 },
    { key: "Before", val: 1 }
  ]
  public generalForm!: FormGroup;
  public payrollForm!: FormGroup;
  public reminderForm!: FormGroup;
  public notificationObj = {
    "add_new_shift": { "mobile": false, "push": "", "email": false },
    "edit_shift": { "mobile": "1", "push": "", "email": "" },
    "exceed_work_hour": { "mobile": "1", "push": "", "email": "" },
    "auto_clock_out": { "mobile": "1", "push": "", "email": "" },
    "request_pending_approval": { "mobile": "1", "push": "", "email": "", "value": "" },
    "submitted_timesheet": { "mobile": "1", "push": "", "email": "" },
    "app_disapp_job": { "mobile": "1", "push": "", "email": "" },
  }
  public limitationObj = {
    "clock_in_limitation": { "cl_li": "1", "li_type": "0", "value": "15", "hmd": "1", "af_bf": "0" },
    "auto_clockout_time": { "cl_li": "1", "li_type": "0", "value": "15", "hmd": "1", "af_bf": "0" },
    "custom_limit_by_day_sun": { "fr": "1", "to": "15", "sun": "1" },
    "custom_limit_by_day_mon": { "fr": "1", "to": "15", "mon": "1" },
    "custom_limit_by_day_tues": { "fr": "1", "to": "15", "tues": "1" },
    "custom_limit_by_day_wed": { "fr": "1", "to": "15", "wed": "1" },
    "custom_limit_by_day_thur": { "fr": "1", "to": "15", "thur": "1" },
    "custom_limit_by_day_fri": { "fr": "1", "to": "15", "fri": "1" },
    "custom_limit_by_day_sat": { "fr": "1", "to": "15", "sat": "1" },
  }
  public limitationArr = [
    { key: "custom_limit_by_day_sun", "fr": "", "to": "", "sun": "1", val: "S", selected: false },
    { key: "custom_limit_by_day_mon", "fr": "", "to": "", "mon": "1", val: "M", selected: false },
    { key: "custom_limit_by_day_tues", "fr": "", "to": "", "tues": "1", val: "T", selected: false },
    { key: "custom_limit_by_day_wed", "fr": "", "to": "", "wed": "1", val: "W", selected: false },
    { key: "custom_limit_by_day_thur", "fr": "", "to": "", "thur": "1", val: "T", selected: false },
    { key: "custom_limit_by_day_fri", "fr": "", "to": "", "fri": "1", val: "F", selected: false },
    { key: "custom_limit_by_day_sat", "fr": "", "to": "", "sat": "1", val: "S", selected: false },
  ]
  //hmd :- 1 = hour, 2 = minute, 
  public breakHourArr: any[] = [
    { key: "5 minutes", hmd: "2", value: 5 },
    { key: "10 minutes", hmd: "2", value: 10 },
    { key: "15 minutes", hmd: "2", value: 15 },
    { key: "20 minutes", hmd: "2", value: 20 },
    { key: "25 minutes", hmd: "2", value: 25 },
    { key: "30 minutes", hmd: "2", value: 30 },
    { key: "35 minutes", hmd: "2", value: 35 },
    { key: "40 minutes", hmd: "2", value: 40 },
    { key: "45 minutes", hmd: "2", value: 45 },
    { key: "50 minutes", hmd: "2", value: 50 },
    { key: "55 minutes", hmd: "2", value: 55 },
    { key: "1 hour", hmd: "1", value: 1 },
    { key: "1.5 hour", hmd: "1", value: 1.5 },
    { key: "2 hour", hmd: "1", value: 2 },
  ]
  public breakHourObj = {
    "break_type": "0",//0: disabled;1: manual;2:automatic;      
  }
  public overtimeSetting = {
    "weekly_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": "1", "s_mv": "2.6" },
    "daily_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": "1", "s_mv": "2.6" },
    "partial_day_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": "1", "s_mv": "2.6" },
    "consecutive_days_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": "1", "s_mv": "2.6" },
    "pay_period_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": "1", "s_mv": "2.6" },
  }
  public overtimeValue: any[] = [
    { key: "X base val", val: "1" },
    { key: "+ base val", val: "2" },
  ];
  public automaticArr: any[] = [
    { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "1" }
  ];
  public geoLocationObj = {
    track: "1"
  }
  public overtimeWeekDays: OvertimeWeekDays = {
    daily_overtime: [],
    premium_time:[],
    night_premium: [],
    partial_day_overtime: [],
    consecutive_days_overtime: [],
  }
  public generalObj = {
    "default_work_hour": { "fr": "10:00", "to": "10:00" },
    daily_limit_exceed: { "value": "5", selected: false, "hmd": "1", "af_bf": "0", },
    auto_clock_out_hour: { "hmd": "1", "af_bf": "0", "value": "10", selected: false },
    show_pay_rates: { "yes_no": "1", selected: false },
    timesheet_rounding: { yes_no: "1", value: "2", selected: false },
    payroll_cycle: { hmd: "3", value: "" },
    timesheet_approval: { "yes_no": "1", selected: false },
    "timesheet_review_user": { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "09:00", selected: false, oth_text: "Please review your work hours in the timesheet!" },
    "timesheet_review_admin": { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "09:00", selected: false, oth_text: "It is time to review your employees' timesheets" },
    // Reminders 
    "reminder_active_on": this.getRemArray(this.remDays),
    "employee_clockin_at": { "value": "10", selected: false },
    "employee_clockout_at": { "value": "20", selected: false },
    // Notification object
    "add_new_shift": { "mobile": false, "push": "", "email": false },
    "edit_shift": { "mobile": "1", "push": "", "email": "" },
    "exceed_work_hour": { "mobile": "1", "push": "", "email": "" },
    "auto_clock_out": { "mobile": "1", "push": "", "email": "" },
    "request_pending_approval": { "mobile": "1", "push": "", "email": "", "value": ""},
    "submitted_timesheet": { "mobile": "1", "push": "", "email": "" },
    "app_disapp_job": { "mobile": "1", "push": "", "email": "" },
    //Limitation object
    "clock_in_limitation": { "cl_li": "1", "value": "15", "hmd": "1", "af_bf": "0", selected: false },
    "auto_clockout_time": { "cl_li": "1", "value": "15", "hmd": "1", "af_bf": "0", selected: false },
    // geolocation
    "geolocation": { track: '1' },
    //breaks
    "manual_breaks": { "yes_no": "0", selected: false },
    "automatic_breaks": this.automaticArr,
    "disable_breaks": { "yes_no": "0", selected: false },
    //overtime
    "weekly_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "daily_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    // "partial_day_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    // "consecutive_days_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "pay_period_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    //limitation custom limit by days
    "custom_limit_by_day_sun" : {"fr": "", "to": "", "sun": "1", val: "S", selected: false },
    "custom_limit_by_day_mon" : {"fr": "", "to": "", "mon": "1", val: "M", selected: false },
    "custom_limit_by_day_tues": {"fr": "", "to": "", "tues": "1", val: "T", selected: false },
    "custom_limit_by_day_wed" : {"fr": "", "to": "", "wed": "1", val: "W", selected: false },
    "custom_limit_by_day_thur": {"fr": "", "to": "", "thur": "1", val: "T", selected: false },
    "custom_limit_by_day_fri":  {"fr": "", "to": "", "fri": "1", val: "F", selected: false },
    "custom_limit_by_day_sat":  {"fr": "", "to": "", "sat": "1", val: "S", selected: false },
    "manager_sign":  { selected: false },
    "employee_confirm_hours":  { selected: false },
    "premium_time": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6" },
    "night_premium": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10","fr": "21","to":"7" ,"s_m": 1, "s_mv": "2.6" },
    "partial_day_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6","fr": "8","to":"11" },
    "consecutive_days_overtime": { "selected": true, "hmd": "1", "af_bf": "0", "value": "10", "s_m": 1, "s_mv": "2.6","st_on":"7" },
  }
  public breakType: string = "disable_breaks"
  constructor(private dialogRef: MatDialogRef<SettingsComponent>, private fb: FormBuilder, private rulesService: RulesService,
    private commonService: CommonService, private appService: AppService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.generalForm = this.fb.group({
      'from': ["09:00"],
      'to': ["17:00"],
      isDailyLimit: [false],
      dailyLimit: [{ value: 2, disabled: true }],
      isAutoClockOut: [false],
      autoClockOut: [{ value: 2, disabled: true }],
      isHighlightDiff: [],
      isHlEmpWkMore: [],
      empWorkedMore: [],
      isHlEmpWkLess: [],
      empWorkedLess: [],
      isTimeSheetRounding: [],
      timeSheetRounding: ["5"],
    })
    this.payrollForm = this.fb.group({
      'weekStartsOn': ['sun'],
      'payrollCycle': ['30'],
      'isTimeSheetApp': [],
      'isRdUserReviewSheet': [],
      'reviewVal': [1],
      'reviewRemTimePeriod': ['0'],
      'reviewRemDur': ['1'],
      'reviewRemTime': ['09:00'],
      'reviewRemText': ["Please review your work hours in the timesheet!"],
      'isRdCmpReviewSheet': [],
      'reviewValCmp': [1],
      'reviewRemTimePeriodCmp': ['0'],
      'reviewRemDurCmp': ['week'],
      'reviewRemTimeCmp': ['09:00'],
      'reviewRemTextCmp': ["It is time to review your employees' timesheets"]
    })
    this.reminderForm = this.fb.group({
      'isRemClIn': [],
      "remClIn": [],
      'isRemClOut': [],
      'remClOut': [],
    })
    this.selectedSetting = this.settingsArr[2];
    this.generalForm.get('isDailyLimit')?.valueChanges.subscribe((isDailyLimit) => {
      if (isDailyLimit) {
        this.generalForm.get('dailyLimit')?.enable();
      } else {
        this.generalForm.get('dailyLimit')?.disable();
      }
    });
    this.generalForm.get('isAutoClockOut')?.valueChanges.subscribe((isDailyLimit) => {
      if (isDailyLimit) {
        this.generalForm.get('autoClockOut')?.enable();
      } else {
        this.generalForm.get('autoClockOut')?.disable();
      }
    });
    this.getSettings()
  }
  onSelectedSettings(item) {
    this.selectedSetting = item;
  }
  onCancel() {
    this.dialogRef.close()
  }
  onClose() {
    this.dialogRef.close();
  }
  toggleDaySelection(day) {
    day.selected = !day.selected;
  }
  onLimitationValueChange(event, type) {
    if (event.value == '1') {
      if (type == "clock_limit") {
        this.generalObj.clock_in_limitation.value = ""
      }
      else {
        this.generalObj.auto_clockout_time.value = ""
      }
    }
    else {
      if (type == "clock_limit" && this.generalObj.clock_in_limitation.value == "") {
        this.generalObj.clock_in_limitation.value = "15"
      }
      if (type == "auto_clockout" && this.generalObj.auto_clockout_time.value == "") {
        this.generalObj.auto_clockout_time.value = "15"
      }
    }
  }
  transformedArray(array: any[], type: string) {
    const transformedObject: any = {};
    array.forEach(item => {
      if (item.selected == true) {
        if ((item.hours == "" || item.hours == null)) { item.hours = "8" }
        transformedObject[item.value] = item.hours;
      }
      else {
        transformedObject[item.value] = "";
      }
      // newWorkDaysArr.push(transformedObject)// Assign "10" to each key
    });
    return transformedObject;
  }
  getRemArray(array: any[]) {
    const transformedObject: any = {};
    array.forEach(item => {
      if (item.selected == true) {
        transformedObject[item.value] = "1";
      }
      else {
        transformedObject[item.value] = "0";
      }
    });
    return transformedObject;
  }
  onTimeChange(value, index) {
    const obj = this.breakHourArr.find(item => item.value == value)
    this.automaticArr[index]["hmd"] = obj["hmd"]
  }
  onAddAutomaticBreak() {
    const obj = { "hmd": "1", "af_bf": "0", "value": "10", "hmd_val": "1" };
    this.automaticArr.push(obj);
  }
  onDeleteBreak(id) {
    this.automaticArr.splice(id, 1);
  }
  onAddDaysOvertime(type: any, val: any) {
    let newArr = this.overtimeWeekDays[type];
    if (newArr.includes(val.value)) {
      newArr.splice(newArr.indexOf(val.value), 1);
    }
    else {
      newArr.push(val.value);
    }
    if (this.generalObj[type].hasOwnProperty(val.value)) {
      delete this.generalObj[type][val.value];
    }
    else {
      const obj = {};
      obj[val.value] = "1";
      this.generalObj[type] = Object.assign(this.generalObj[type], obj);
    }
  }
  getSelectedDays(type: any, val: any) {
    if (this.overtimeWeekDays[type].includes(val)) {
      return true;
    }
    return false;
  }
  setSettings(obj) {
    this.workdays = this.workdays.map(day => {
      if (obj.hasOwnProperty(day.value)) {
        const hours = obj[day.value];
        return {
          ...day,
          selected: hours !== "" && hours !== null,
          hours: hours !== "" ? String(hours) : day.hours
        };
      }
      return day;
    });
  }
  getSettings() {
    const obj = {
      "r_type": this.data?.r_type,
      "em_i" : this.data?.em_i,
      "u_t" : this.data?.u_t,
    }

    this.rulesService.getRules(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          let data = success.msg;
          for (let [key, val] of Object.entries(data)) {
            if (key in this.generalObj) {
              this.generalObj[key] = val;
              if (key == "reminder_active_on") {
                for (let i = 0; i < this.remDays.length; i++) {
                  if (this.generalObj[key][this.remDays[i].value] == "1") {
                    this.remDays[i]["selected"] = true
                  }
                }
              }
              for (let i = 0; i < this.limitationArr.length; i++) {
                const keyValue = this.limitationArr[i].key;
                if (this.generalObj.hasOwnProperty(keyValue)) {
                  this.limitationArr[i]["fr"] = this.generalObj[keyValue]["fr"];
                  this.limitationArr[i]["to"] = this.generalObj[keyValue]["to"];
                  this.limitationArr[i]["selected"] = this.generalObj[keyValue]["selected"]
                }
              }
            }
            this.automaticArr = [];
            if (data.hasOwnProperty('work_days_length_limit')) {
              this.setSettings(data["work_days_length_limit"])
            }
            if (data.hasOwnProperty('disable_breaks')) { this.breakType = "disable_breaks" }
            if (data.hasOwnProperty('manual_breaks')) { this.breakType = "manual_breaks" }
            if (data.hasOwnProperty('automatic_breaks')) {
              this.breakType = "automatic_breaks"
              this.automaticArr = data["automatic_breaks"]
            }
          }
           //daily,partial and consecutive overtimes are selected then below function is logic to set the selected week days
           this.setSelectedWorkdays(data, 'daily_overtime')
           this.setSelectedWorkdays(data, 'partial_day_overtime')
           this.setSelectedWorkdays(data, 'consecutive_days_overtime')
           this.setSelectedWorkdays(data, 'premium_time')
        }

        // this.dialogRef.close()
      },
      error: (error: any) => {
        //this.isSpinnerLoading = false
        this.commonService.handleError(error);
      }
    })
  }
  setSelectedWorkdays(data, node_name) {
    const newArr = ['sun', 'mon', 'tues', 'wed', 'thur', 'fri', 'sat']
    if (data.hasOwnProperty(node_name)) {
      for (let key of Object.keys(data[node_name])) {
        if (newArr.includes(key)) {
          this.overtimeWeekDays[node_name].push(key)
        }
      }
    }
  }
  onSubmitRules() {
    this.callApi(this.generalObj)
  }
  callApi(obj) {
    obj["r_type"] = this.data?.r_type;
    obj["u_t"] = this.data?.u_t;
    obj["u_id"] = this.data?.u_id;

    obj["reminder_active_on"] = this.getRemArray(this.remDays)
    obj["work_days_length_limit"] = this.transformedArray(this.workdays, 'general')

    for (let i = 0; i < this.limitationArr.length; i++) {
      if (this.limitationArr[i]["selected"] == true) {
        const { key, val, ...remainingProperties } = this.limitationArr[i];   // Remove unwanted keys from the original object
        const limitObj = { [key]: remainingProperties };        // Create a new object with the remaining properties
        Object.assign(obj, limitObj);
      }
    }
    if (this.breakType == "disable_breaks") {
      obj["disable_breaks"] = { "yes_no": "1", selected: true },
        delete obj["automatic_breaks"]
      delete obj["manual_breaks"]
    }
    else if (this.breakType == "manual_breaks") {
      obj["manual_breaks"] = { "yes_no": "1", selected: true },
        delete obj["automatic_breaks"]
      delete obj["disable_breaks"]
    }
    else {
      obj["automatic_breaks"] = this.automaticArr
      delete obj["manual_breaks"]
      delete obj["disable_breaks"]
    }

    this.rulesService.submitRules(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg)
          this.dialogRef.close()
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }
}
